import React from 'react';
export function EmotionalTransition() {
  return <section className="py-20 px-4 bg-blue-800 text-white text-center" data-id="element-43">
      <div className="max-w-3xl mx-auto" data-id="element-44">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 leading-tight" data-id="element-45">
          Per questo abbiamo creato il Mega-Pack Yoga e Mindfulness per Bambini.
        </h2>
        <p className="text-xl md:text-2xl mb-6 text-blue-100 font-medium" data-id="element-46">
          Una raccolta completa di risorse che ti permette di introdurre yoga,
          respirazione e mindfulness nella vita dei bambini in modo semplice,
          naturale e divertente.
        </p>
        <p className="text-2xl font-bold text-white bg-blue-900/50 inline-block px-6 py-3 rounded-xl" data-id="element-47">
          Tutto è già organizzato e pronto all'uso.
        </p>
      </div>
    </section>;
}